import React from "react";
import { Link } from "react-router-dom";

export const btn = {
  gold: "inline-flex items-center justify-center gap-2 bg-gold text-forest font-semibold tracking-wide uppercase text-[13px] px-8 py-4 rounded-sm hover:bg-gold-light transition-colors duration-300",
  forest: "inline-flex items-center justify-center gap-2 bg-forest text-white font-semibold tracking-wide uppercase text-[13px] px-8 py-4 rounded-sm hover:bg-forest-light transition-colors duration-300",
  outline: "inline-flex items-center justify-center gap-2 border border-forest text-forest font-semibold tracking-wide uppercase text-[13px] px-8 py-4 rounded-sm hover:bg-forest hover:text-white transition-colors duration-300",
  outlineLight: "inline-flex items-center justify-center gap-2 border border-white/40 text-white font-semibold tracking-wide uppercase text-[13px] px-8 py-4 rounded-sm hover:bg-white hover:text-forest transition-colors duration-300",
};

export const Overline = ({ children, className = "", light = false }) => (
  <span
    className={`block text-xs sm:text-sm font-bold uppercase tracking-[0.25em] ${
      light ? "text-gold" : "text-gold"
    } ${className}`}
  >
    {children}
  </span>
);

export const CtaLink = ({ to, variant = "gold", children, ...props }) => (
  <Link to={to} className={btn[variant]} {...props}>
    {children}
  </Link>
);

export const Container = ({ children, className = "" }) => (
  <div className={`max-w-7xl mx-auto px-6 md:px-12 ${className}`}>{children}</div>
);
